import { call, put, takeEvery, select, fork } from "redux-saga/effects"
import { toast } from "react-toastify"
// Crypto Redux States
import RtwImageType from "./actionTypes"

import RtwImageAction from "./actions"
import moment from "moment"
import RtwImageAPI from "helpers/rtw_image_backend_helper"

function* fetchListOnPage({ payload }) {
  yield put(
    RtwImageAction.getListPageSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    const currentPage = payload.page
    let { data } = yield call(RtwImageAPI.getListPage, {
      ...payload,
      page: currentPage,
    })
    yield put(
      RtwImageAction.getListPageSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      RtwImageAction.getListPageSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchDetail({ payload, action }) {
  yield put(
    RtwImageAction.getDetailSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(RtwImageAPI.getDetail, payload.id)

    action(data)
    yield put(
      RtwImageAction.getDetailSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error)
    yield put(
      RtwImageAction.getDetailSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchPostData({ payload, action }) {
  yield put(
    RtwImageAction.postDataSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    const form = new FormData()
    form.append("name", payload.name)
    form.append("file", payload.file)

    let { data } = yield call(RtwImageAPI.postData, form)

    yield put(
      RtwImageAction.postDataSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    console.log(error)
    yield put(
      RtwImageAction.postDataSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchPutData({ payload, action }) {
  yield put(
    RtwImageAction.putDataSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    const form = new FormData()
    form.append("name", payload.name)
    if (payload.file) {
      form.append("file", payload.file)
    }
    if (!payload.file) {
      form.append("imageUrl", payload.file.preview)
    }

    let { data } = yield call(RtwImageAPI.putData, {
      id: payload.id,
      params: form,
    })

    yield put(
      RtwImageAction.putDataSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    console.log(error)
    yield put(
      RtwImageAction.putDataSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* rtwImagesSaga() {
  yield takeEvery(RtwImageType.GET_RTW_IMAGE_PAGES, fetchListOnPage)
  yield takeEvery(RtwImageType.GET_DETAIL_RTW_IMAGE_BY_ID, fetchDetail)
  yield takeEvery(RtwImageType.POST_RTW_IMAGE, fetchPostData)
  yield takeEvery(RtwImageType.PUT_RTW_IMAGE, fetchPutData)
}

export default rtwImagesSaga
